// extracted by mini-css-extract-plugin
export default {"loader":"ChartLoaderView_loader__PZ388","loader__message":"ChartLoaderView_loader__message__5DByD"};